export function checkDigit (id)
{
    let sum = 0;
    let mul = 2;

    for (let i = id.length - 1; i >= 0; i--)
    {
        sum = sum + Number(id.charAt(i)) * mul;
        mul = (mul + 1) % 8 || 2;
    }

    switch (sum % 11)
    {
        case 1:
            return 'K';

        case 0:
            return '0';

        default:
            return (11 - (sum % 11)).toString();
    }
}

export function clean (rut)
{
    if (!rut)
        return '';

    return rut.replace(/[.-]/g, '');
}

export function isValid (id)
{
    id = clean(id);

    if (id.length < 7)
        return false;

    let dv = id.charAt(id.length - 1);
    dv = dv === 'k' ? 'K' : dv;

    const dvC = checkDigit(id.substring(0, id.length - 1));

    return dv === dvC.toString();
}
